import api from "@/api.js";
import business from "./business/";
import solutions from "./solutions/";

export default {
  namespaced: true,
  modules: {
    business,
    solutions,
  },
  state: {
    list: [],
    outcomesGoalsList: [],
    basicGoals: [],
    listLoading: false,
    selectedGoal: null,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setOutcomesGoalsList(state, payload) {
      state.outcomesGoalsList = payload;
    },
    setBasicGoals(state, payload) {
      state.basicGoals = payload;
    },
    setSelectedGoal(state, payload) {
      state.selectedGoal = payload;
    },
  },
  actions: {
    async loadBySourceID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("goals/bySourceID", { params: { id: id } });
      commit("setSelectedGoal", list.data[0]);
      commit("setListLoading", false);
    },
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("goals");
      commit("setList", list.data);
      commit("setListLoading", false);
    },

    async loadAllGoalsAndBasicGoalsByOutcomeID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("goals/goalsAndBasicGoals/byOutcomeID", {
        params: { id: id },
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllForOutcome({ commit }, payload) {
      commit("setListLoading", true);

      let list = await api.get("goals/forOutcome", {
        params: {
          id: payload,
        },
      });
      commit("setOutcomesGoalsList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("goals/byID", { params: { id: id } });
      commit("setSelectedGoal", list.data[0]);
      commit("setListLoading", false);
    },
    async loadByIDWithEmissionsFactor({ commit }, payload) {
      commit("setListLoading", true);
      let list = await api.get("goals/byIDWithEmissionsFactor", {
        params: { id: payload.id, year: payload.year },
      });
      commit("setSelectedGoal", list.data[0]);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("goals", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      return returnData;
    },

    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`goals`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      return returnData;
    },
    async delete({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`goals/delete`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      return returnData;
    },

  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    outcomesGoalsList(state) {
      return state.outcomesGoalsList;
    },
    basicGoals(state) {
      return state.basicGoals;
    },
    selectedGoal(state) {
      return state.selectedGoal;
    },
  },
};
